import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment';

import { GrainRegistrationItem } from '../models/grain-registration.model';

@Injectable({
  providedIn: 'root',
})
export class GrainRegistrationService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly arableServiceUrl = `${this.env.APIM_BASE_URL}/arable-service`;

  getRegistrationHistory(cropYear: number) {
    return this.http.get<Array<GrainRegistrationItem>>(
      `${this.arableServiceUrl}/grainregistration/registration/${cropYear}`,
      {},
    );
  }

  getRegistrationHistoryDocument(id: string) {
    return this.http.get(`${this.arableServiceUrl}/grainregistration/registration/document/${id}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
